import { FC } from 'react'

import { SlideItemProps } from '../constants'
import SlideItem from '../SlideItem'

import { Bar, BarWrapper, ListWrapper, SliderWrapper } from './Slide.style'
import SlideDownArrow from './SlideDownArrow'

interface SlideProps {
  slide: number
  setSlide: (arg: number) => void
  slideItems: SlideItemProps[]
}

const Slide: FC<SlideProps> = ({ slide, setSlide, slideItems }) => {
  const isLastSlide = slideItems.length - 1 === slide

  return (
    <SliderWrapper>
      <BarWrapper>
        <Bar />
        <ListWrapper>
          {slideItems.map((item: SlideItemProps, index) => (
            <SlideItem
              key={index}
              item={item}
              currentKey={index}
              selected={slide}
              setSlide={setSlide}
            />
          ))}
        </ListWrapper>
      </BarWrapper>
      <SlideDownArrow isLastSlide={isLastSlide} />
    </SliderWrapper>
  )
}

export default Slide
